export enum UploadLinkCodeRejectionReason {
  Malformed = 'Malformed',
  NotFound = 'NotFound',
  TenantMismatch = 'TenantMismatch',
  Inactive = 'Inactive',
  Expired = 'Expired',
}

export interface IUploadLinkCodeRejection {
  message: string;
  reason: UploadLinkCodeRejectionReason;
}
